import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  choosePaymentMethod: {
    id: 'payAtPump:thereAreSomePaymentMethodsAdded:choosePaymentMethodButtonTitle',
    defaultMessage: 'Choose payment method',
    description: 'Pay at pump, there are some payment methods added - Choose payment method button title',
  },
  chooseAnotherPaymentMethod: {
    id: 'payAtPump:expiredCard:chooseAnotherPaymentMethod',
    defaultMessage: 'This card is expired. Please choose another payment method or add a new one.',
    description: 'Pay at pump - if card is expired. Please choose another payment method or add a new one.',
  },
  payAtPumpAddPaymentInstrumentButtonTitle: {
    id: 'pay-at-pump:add-payment-instrument-button:title',
    defaultMessage: 'Add payment method',
    description: 'Pay at pump, Add payment instrument button title',
  },
  payAtPumpAddCarWashButtonText: {
    id: 'pay-at-pump:add-car-wash-button:text',
    defaultMessage: 'Add car wash',
    description: 'Pay at pump, add Car Wash button text',
  },
  payAtPumpPayWithCardButtonTitle: {
    id: 'pay-at-pump:pay-with-card-button:title',
    defaultMessage: 'Pay',
    description: 'Pay at pump, pay with card button title',
  },
  payAtPumpPaymentInstrumentBalance: {
    id: 'pay-at-pump:payment-instrument:balance',
    defaultMessage: 'Balance {balance}',
    description: 'Pay at pump, the label for payment instrument balance',
  },
  payAtPumpPaymentInstrumentExpiredErrorMessages: {
    id: 'pay-at-pump:payment-instrument-expired-error:messages',
    defaultMessage: 'Card is expired',
    description: 'Pay at pump, payment method expired message',
  },
  payAtPumpSizeLimitReachedSnackbarTitle: {
    id: 'pay-at-pump:size-limit-reached:snackbar:title',
    defaultMessage: "You've reached the limit. Delete an existing payment method to add a new one.",
    description: 'Pay at pump, Popup title when user tries add a card out of the wallet size limit',
  },
});
